import { NgModule, Pipe, PipeTransform } from "@angular/core";
import Autolinker, { AutolinkerConfig } from "autolinker";

@Pipe({
    name: 'kfLinky',
    standalone: false
})
export class kfLinkyPipe implements PipeTransform {
    transform(value: string, options?: AutolinkerConfig): string {
        return Autolinker.link(value, options);
    }
}

@NgModule({
    imports: [],
    declarations: [kfLinkyPipe],
    exports: [kfLinkyPipe],
})

export class PipeModule {
    static forRoot() {
        return {
            ngModule: PipeModule,
            providers: []
        }
    }
}
